<script setup>
import { computed, defineProps } from 'vue';
import starIcon from '@/assets/images/screening/detail/star.svg';
import bulbIcon from '@/assets/images/screening/detail/bulb.svg';
import { readConclusionCopy, toConclusionHtml } from './screeningConclusion';

const props = defineProps({
	source: { type: Object, default: null },
});

const insights = computed(() => readConclusionCopy(props.source));
const meaningHtml = computed(() => toConclusionHtml(insights.value.meaning));
const html = (value) => toConclusionHtml(value);
</script>

<template>
	<div
		v-if="insights.meaning || insights.items.length"
		class="insights"
	>
		<section v-if="insights.meaning" class="insights__block">
			<div class="insights__head">
				<span class="insights__badge">
					<img :src="starIcon" alt="" width="20" height="20" />
				</span>
				<h2>Ý nghĩa</h2>
			</div>
			<div class="insights__body" v-html="meaningHtml"></div>
		</section>
		<section v-if="insights.items.length" class="insights__block">
			<div class="insights__head">
				<span class="insights__badge">
					<img :src="bulbIcon" alt="" width="20" height="20" />
				</span>
				<h2>Gợi ý tiếp theo cho phụ huynh</h2>
			</div>
			<div class="insights__list">
				<div
					v-for="(item, index) in insights.items"
					:key="index"
					class="insights__item"
				>
					<p v-if="item.title">{{ item.title }}</p>
					<div v-if="item.content" v-html="html(item.content)"></div>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.insights {
	display: flex;
	flex-direction: column;
	gap: 40px;
}

.insights__block {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.insights__head {
	display: flex;
	align-items: center;
	gap: 16px;

	h2 {
		flex: 1;
		min-width: 0;
		margin: 0;
		color: #344256;
		font-size: 20px;
		line-height: 28px;
		font-weight: 600;
	}
}

.insights__badge {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	border-radius: 100px;
	background: #6366f1;
	flex-shrink: 0;

	img {
		width: 20px;
		height: 20px;
	}
}

.insights__body,
.insights__list {
	padding-left: 60px;
	color: #344256;
	font-size: 16px;
	line-height: 24px;
}

.insights__list {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.insights__item {
	display: flex;
	flex-direction: column;
	gap: 4px;

	> p {
		margin: 0;
		font-weight: 600;
	}
}

.insights__body :deep(p),
.insights__item :deep(p) {
	margin: 0;
}

.insights__body :deep(p + p),
.insights__item :deep(p + p) {
	margin-top: 8px;
}

.insights__body :deep(a),
.insights__item :deep(a) {
	color: #2aa797;
	text-decoration: underline;
}
</style>
